import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { checkoutAPI } from '../api/checkoutAPI';

export const useGetMaxAmout = () => {
  const initData = useMemo(() => ({ amount: 0 }), []);
  const { data = initData, isLoading } = useQuery({
    queryKey: ['max-amount'],
    queryFn: async () => await checkoutAPI.maxAmout(),
    select: data => ({
      amount: data.data.amount,
    }),
  });
  return {
    ...data,
    isLoading,
  };
};
